'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toast = exports.ToastContainer = undefined;

var _ToastContainer = require('./ToastContainer');

var _ToastContainer2 = _interopRequireDefault(_ToastContainer);

var _toastify = require('./toastify');

var _toastify2 = _interopRequireDefault(_toastify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ToastContainer = _ToastContainer2.default;
exports.toast = _toastify2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-toastify/lib/index.js
 ** module id = 1570
 ** module chunks = 0
 **/